import './profileSteps.scss';
import './profileInvestmentPlan.scss';

import React from 'react';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { AmountInput } from 'commonsComponents/amountInput';
import { LoadingSection } from 'commonsComponents/loadingSection';
import { OKLink } from 'commonsComponents/OKLink';
import Accordion from 'components/commons/accordion/accordion';
import AccordionBody from 'components/commons/accordion/accordionBody/accordionBody';
import FormattedTextWithComponents from 'components/FormattedTextWithComponents/FormattedTextWithComponents';
import Headline from 'components/headline';
import HighLightedText from 'components/highLightedText/highLightedText';
import RAContributionPeriodicity from 'components/RAComponents/RAContributionPeriodicity/RAContributionPeriodicity';
import RAExpectedProfitability from 'components/RAComponents/RAExpectedProfitability/RAExpectedProfitability';
import RAIndexRiskModal from 'components/RAComponents/RAIndexRiskModal/RAIndexRiskModal';
import RAPortfolioCompositionTable from 'components/RAComponents/RAPortfolioCompositionTable/RAPortfolioCompositionTable';
import RAPortfolioDonut from 'components/RAComponents/RAPortfolioDonut/RAPortfolioDonut';
import RAStrategyCards from 'components/RAComponents/RAStrategyCards/RAStrategyCards';
import { RoadmapNavigation } from 'components/steps/RoadmapNavigation/RoadmapNavigation';
import RARejected from 'components/RAComponents/RARejected/RARejected';
import { LoginRoboContainer } from 'components/RAComponents/LoginRobo/LoginRoboContainer';
import RASuitabilityTestWrapper from 'components/RAComponents/RASuitabilityTestWrapper/RASuitabilityTestWrapper';
import { goToErrorsView, recordAndSavePage } from 'actions/errorViewNavigation';
import expectedProfitabilityActions from 'actions/RAExpectedProfitability';
import { actions as formActions } from 'react-redux-form';
import raHireManagementPlanActions from 'actions/RAHireManagementPlan';
import raManagementPlanActions from 'actions/RAManagementPlan';
import raPortfolioDistributionActions from 'actions/RAPortfolioDistribution';
import raSuitabilityTestActions from 'actions/RASuitabilityTest';
import raSimulationActions from 'actions/RASimulation';
import stepsActions from 'actions/stepsActions';
import preLoaderActions from 'actions/preLoaderActions';
import modalCancelActions from 'actions/modalCancelActions';
import { FormattedText, formatText, getLanguage } from 'core/i18n';
import { base64ToBlob, downloadAsFile } from 'utilities/APIRequestHelper';
import UtagHelper from 'utilities/utagHelper';
import { PUBLICA_URL_ROOT } from 'constants/index';
import cryptoJS from 'crypto-js';
import { ERROR_AL_ENVIAR_SIMULACION } from 'constants/analyticsErrors';
import {
    EURO_SYMBOL,
    MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
    RA_PROJECTION_CHART_ALL_PRODUCTS,
    INVESTMENT_PROCESS_PDF,
} from 'constants/RAConstants';
import {
    EVENT_CATEGORY_INVESTMENT_PLAN,
    EVENT_ACTION_INVESTMENT_PLAN,
    INVEST_PROFILE,
    EVENT_ACTION_SHOW_PORTFOLIO_MANAGMENT_CONTRACT,
    EVENT_ACTION_SHOW_RISK_INDEX,
    EVENT_DETAIL_RENTABILITY_DETAIL,
    SIMULATION_ROBO_NAME,
    EVENT_DETAIL_RECURRING_CONTRIBUTION,
    EVENT_DETAIL_PROJECTION,
    EVENT_ACTION_DISTRIBUTION_DETAIL,
    EVENT_ACTION_CURRENT_DISTRIBUTION,
    EVENT_DETAIL_MODAL_OPEN_DEFAULT,
    EVENT_DETAIL_BUTTON_CLOSE,
    EVENT_DETAIL_SELECTED_STRATEGY,
    EVENT_DETAIL_BUTTON_NEXT,
    EVENT_DETAIL_BUTTON_PREV,
    EVENT_CATEGORY_RA_REJECTED,
    EVENT_ACTION_RA_REJECTED,
} from 'constants/uTagConstants/RAConstants';
import { PATH_ROBO_INVESTMENT_PLAN, PATH_RA_REJECTED } from 'constants/uTagConstants/paths';

class ProfileInvestmentPlan extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isClicked: false,
            showRiskModal: false,
        };

        this.handleCloseRiskModal = this.handleCloseRiskModal.bind(this);
        this.handleContributionCheckboxChange = this.handleContributionCheckboxChange.bind(this);
        this.handleContributionDayChange = this.handleContributionDayChange.bind(this);
        this.handleInitialContributionChange = this.handleInitialContributionChange.bind(this);
        this.handleManagementPDFClick = this.handleManagementPDFClick.bind(this);
        this.handlePeriodicityChange = this.handlePeriodicityChange.bind(this);
        this.handleProjectionChartYearsClick = this.handleProjectionChartYearsClick.bind(this);
        this.handleRecurringContributionChange = this.handleRecurringContributionChange.bind(this);
        this.handleRiskLinkClick = this.handleRiskLinkClick.bind(this);
        this.handleStrategyClick = this.handleStrategyClick.bind(this);
        this.handleStrategyDetailsClick = this.handleStrategyDetailsClick.bind(this);
        this.sendOkSimulation = this.sendOkSimulation.bind(this);
        this.gotoNextStep = this.gotoNextStep.bind(this);
        this.buildProfileInvestmentPlan = this.buildProfileInvestmentPlan.bind(this);
    }

    UNSAFE_componentWillMount() {
        window.scrollTo(0, 0);
    }

    componentDidMount() {
        const {
            userProfile: { recordId, userId, product, promoCode, investmentType, accessToken, docNumber },
            products,
            raPortfolioDistributionActions,
            raHireManagementPlanActions,
            immCheckStatus,
            recordAndSavePage,
        } = this.props;

        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        recordAndSavePage(
            PATH_ROBO_INVESTMENT_PLAN,
            recordId,
            userId,
            product,
            products.get('productsDescription'),
            promoCode ? promoCode : '',
            false,
            '',
            '',
            investmentType,
            {
                identificadorOnboarding: docNumberEncrypted,
            }
        );

        if (immCheckStatus.get('checkStatus')) {
            raPortfolioDistributionActions.requestPortfolioDistribution(accessToken);
            raHireManagementPlanActions.getPDFContract(accessToken);
        }
    }

    updateCharts = immManagementPlan => {
        const product = immManagementPlan.get('investProfileValue');
        this.requestLineChart(product);
        this.requestBarChart(product);
    };

    handleStrategyClick(value) {
        const { userProfile, raManagementPlanActions } = this.props;
        raManagementPlanActions.selectStrategy(value);
        this.requestLineChart(value);
        const strategy = INVEST_PROFILE[value];
        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_CATEGORY_INVESTMENT_PLAN,
            `${EVENT_DETAIL_SELECTED_STRATEGY} - ${strategy}`,
            userProfile
        );
    }

    handleStrategyDetailsClick() {
        this.props.raManagementPlanActions.showDetails();

        // This scrolls to the details section
        setTimeout(() => {
            const elementTo = document.querySelector('#investmentPlanViewDetailsAnchor');

            elementTo.scrollIntoView();
        }, 200);
    }

    handleProjectionChartYearsClick(value) {
        const { expectedProfitabilityActions, userProfile, immManagementPlan } = this.props;
        expectedProfitabilityActions.changeYears(value);
        this.requestLineChart(immManagementPlan.get('investProfileValue'));

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_CATEGORY_INVESTMENT_PLAN,
            `${EVENT_DETAIL_PROJECTION} - ${value} años`,
            userProfile
        );
    }

    handleInitialContributionChange(value) {
        const { raManagementPlanActions, immManagementPlan } = this.props;
        raManagementPlanActions.setInitialContributionAmount(value);
        this.updateCharts(immManagementPlan);
    }

    handleContributionDayChange(evt) {
        const selectedDay = parseInt(evt.currentTarget.dataset.id);
        const { immManagementPlan } = this.props;
        if (selectedDay !== immManagementPlan.get('recurringContributionDay')) {
            this.props.raManagementPlanActions.setContributionDay(selectedDay);
            this.updateCharts(immManagementPlan);
        }
    }

    handlePeriodicityChange(evt) {
        const { raManagementPlanActions, immManagementPlan } = this.props;
        raManagementPlanActions.setPeriodicity(evt.value);
        this.updateCharts(immManagementPlan);
    }

    handleRecurringContributionChange(value) {
        const { raManagementPlanActions, immManagementPlan } = this.props;
        const amount = value || 0;
        raManagementPlanActions.setRecurringContributionAmount(amount);
        this.updateCharts(immManagementPlan);
    }

    handleContributionCheckboxChange(evt) {
        const { raManagementPlanActions, userProfile } = this.props;
        const {
            target: { checked },
        } = evt;

        raManagementPlanActions.setHasRecurringContribution(checked);
        if (!checked) this.handleRecurringContributionChange(null);

        const status = checked ? 'check' : 'uncheck';

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_CATEGORY_INVESTMENT_PLAN,
            `${EVENT_DETAIL_RECURRING_CONTRIBUTION} - ${status}`,
            userProfile
        );
    }

    handleRiskLinkClick = () => {
        const { userProfile } = this.props;

        this.setState({
            showRiskModal: true,
        });

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_CATEGORY_INVESTMENT_PLAN,
            EVENT_ACTION_SHOW_RISK_INDEX,
            userProfile
        );
    };

    handleManagementPDFClick() {
        const { userProfile, immHireManagementPlan } = this.props;
        const documentContent = immHireManagementPlan.get('pdfLink');
        const base64String = `data:application/pdf;base64,${documentContent}`;

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_CATEGORY_INVESTMENT_PLAN,
            EVENT_ACTION_SHOW_PORTFOLIO_MANAGMENT_CONTRACT,
            userProfile
        );

        downloadAsFile(base64ToBlob(base64String), 'application/pdf', `Contrato GD.pdf`); // TBC: Filename
    }

    handleCloseRiskModal() {
        this.setState({
            showRiskModal: false,
        });
    }

    requestLineChart(product = RA_PROJECTION_CHART_ALL_PRODUCTS) {
        const {
            userProfile: { accessToken },
            expectedProfitabilityActions,
        } = this.props;
        expectedProfitabilityActions.requestProjectionChart(accessToken, { product });
    }

    requestBarChart(product = RA_PROJECTION_CHART_ALL_PRODUCTS) {
        const {
            userProfile: { accessToken },
            expectedProfitabilityActions,
        } = this.props;
        expectedProfitabilityActions.requestProjectionChart(accessToken, {
            dataPoints: 2,
            chartYears: 0,
            product,
        });
    }

    gotoNextStep() {
        const { userProfile, actions, immStepsState, immManagementPlan } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = this.props.immStepsState.get('readOnlyForms');
        const value = immManagementPlan.get('investProfileValue');

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            EVENT_CATEGORY_INVESTMENT_PLAN,
            EVENT_ACTION_INVESTMENT_PLAN,
            INVEST_PROFILE[value],
            userProfile
        );

        if (!disabled) {
            actions.finalizeStep({
                index: currentIndex,
                finished: true,
            });
            actions.enableFinishedAndNextStep();
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        } else {
            actions.changeCurrentStep({
                index: currentIndex + 1,
            });
        }

        this.setState({ isClicked: false });
    }

    handlePrevStep = () => {
        const { immStepsState, actions } = this.props;
        const currentStep = immStepsState.get('currentStep');

        actions.changeCurrentStep({
            index: parseInt(currentStep) - 1,
        });
    };

    onHandleOnContinue = () => {
        const {
            immStepsState,
            raSimulationActions,
            preLoaderActions,
            userProfile: { accessToken },
        } = this.props;
        const currentIndex = immStepsState.get('currentStep');
        const currentStep = immStepsState.getIn(['steps', currentIndex]);

        if (currentStep.get('finished')) {
            this.gotoNextStep();
        } else {
            preLoaderActions.showPreLoader();
            raSimulationActions.saveSimulation(accessToken, isSaved => {
                if (isSaved) {
                    this.sendOkSimulation();
                } else {
                    this.setState({ isClicked: false });
                }
            });
        }
        this.setState({ isClicked: true });
    };

    sendOkSimulation() {
        const { userProfile, raSimulationActions, preLoaderActions, goToErrorsView } = this.props;
        raSimulationActions.sendOkSimulation(userProfile.accessToken, verifiedOk => {
            preLoaderActions.hidePreLoader();
            if (verifiedOk) {
                this.gotoNextStep();
            } else {
                goToErrorsView({ errorMessage: ERROR_AL_ENVIAR_SIMULACION });
                this.setState({ isClicked: false });
            }
        });
    }

    recordDetailAccordion = expanded => {
        const { userProfile } = this.props;

        const eventDetail = expanded ? EVENT_DETAIL_MODAL_OPEN_DEFAULT : EVENT_DETAIL_BUTTON_CLOSE;

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_ACTION_DISTRIBUTION_DETAIL,
            eventDetail,
            userProfile
        );
    };

    recordCurrentAccordion = expanded => {
        const { userProfile } = this.props;

        const eventDetail = expanded ? EVENT_DETAIL_MODAL_OPEN_DEFAULT : EVENT_DETAIL_BUTTON_CLOSE;

        UtagHelper.recordEventRoboGBI(
            PATH_ROBO_INVESTMENT_PLAN,
            SIMULATION_ROBO_NAME,
            EVENT_ACTION_CURRENT_DISTRIBUTION,
            eventDetail,
            userProfile
        );
    };

    getInvestProfileValue() {
        const { immManagementPlan, immTimeHorizonCheck } = this.props;
        const maxInvestProfileValue = immTimeHorizonCheck.get('maxTypeOfProduct');
        const candidateProfileValue = immManagementPlan.get('investProfileValue') || 0;

        return maxInvestProfileValue >= candidateProfileValue ? candidateProfileValue : 0;
    }

    getStrategyCards() {
        const { immManagementPlan, immStepsState } = this.props;
        let strategyContent = <LoadingSection />;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        if (!immManagementPlan.get('isFetchingInvestProfile')) {
            const investProfileValue = this.getInvestProfileValue();

            strategyContent = (
                <div>
                    <RAStrategyCards
                        maxAvailable={this.props.immTimeHorizonCheck.get('maxTypeOfProduct')}
                        onStrategyDetailsClick={this.handleStrategyDetailsClick}
                        onSelectStrategy={this.handleStrategyClick}
                        selectedCard={investProfileValue}
                        disabled={disabled}
                    />
                </div>
            );
        }

        return strategyContent;
    }

    buildDetailsSection() {
        const { immManagementPlan } = this.props;
        let detailsSection,
            donutContent,
            tableContent = null;

        if (!immManagementPlan.get('isFetchingInvestProfile')) {
            const investProfileValue = this.getInvestProfileValue();

            if (investProfileValue > 0) {
                const { immManagementPlan, immPortfolioDistribution, userProfile } = this.props;
                const initialContributionAmount = immManagementPlan.get('initialContributionAmount');
                const recurringContributionAmount = immManagementPlan.get('recurringContributionAmount');
                const immAssetAllocations = immPortfolioDistribution.getIn(
                    ['portfolio', investProfileValue.toString(), 'assetAllocations'],
                    []
                );
                const strategyName = `raPortfolioDistribution-strategy${investProfileValue}`;
                const strategyIcon = `investment-plan__icon investment-plan__icon--${investProfileValue}`;
                const moreInfoLinkURL = `${PUBLICA_URL_ROOT}${INVESTMENT_PROCESS_PDF}`;
                const moreInfoLink = (
                    <OKLink
                        modifier="emphasize"
                        to={moreInfoLinkURL}
                        target="_blank"
                        onClick={() => {
                            UtagHelper.recordEventRoboGBI(
                                PATH_ROBO_INVESTMENT_PLAN,
                                SIMULATION_ROBO_NAME,
                                EVENT_CATEGORY_INVESTMENT_PLAN,
                                EVENT_DETAIL_RENTABILITY_DETAIL,
                                userProfile
                            );
                        }}
                    >
                        <span>
                            <i className="icon-document" />
                            <FormattedText value="investmentPlan-moreInfoLink" />
                        </span>
                    </OKLink>
                );
                const moreInfoLinkManagement = (
                    <OKLink modifier="emphasize" onClick={this.handleManagementPDFClick}>
                        <FormattedText value="investmentPlan-moreInfoText3Link" />
                    </OKLink>
                );
                let graph = null;

                if (immPortfolioDistribution.get('isFetching')) {
                    donutContent = <LoadingSection />;
                    tableContent = <LoadingSection />;
                } else if (immAssetAllocations) {
                    donutContent = <RAPortfolioDonut immAssetAllocations={immAssetAllocations} />;
                    tableContent = (
                        <RAPortfolioCompositionTable
                            immAssetAllocations={immAssetAllocations}
                            immManagementPlan={immManagementPlan}
                        />
                    );
                }

                const validRecurringContribution = !recurringContributionAmount
                    ? true
                    : recurringContributionAmount >= 1;

                if (initialContributionAmount && validRecurringContribution) {
                    const { immExpectedProfitability } = this.props;
                    const chartButtons = immExpectedProfitability.get('chartButtons');
                    const chartData = immExpectedProfitability
                        .getIn(['productsChartData', `${investProfileValue - 1}`])
                        .toJS();
                    const chartYears = immExpectedProfitability.get('chartYears');
                    const chartDataFetching = immExpectedProfitability.get('isFetching');

                    graph = (
                        <RAExpectedProfitability
                            chartButtons={chartButtons}
                            chartData={chartData}
                            chartYears={chartYears}
                            loading={chartDataFetching}
                            onChangeYears={this.handleProjectionChartYearsClick}
                            subtitle={formatText('rentabilityGraph-expectedRentabilityDescription')}
                            title={formatText('rentabilityGraph-expectedRentability')}
                        />
                    );
                }

                detailsSection = (
                    <div className="row">
                        <div className="col-md-12">
                            <div className="investment-plan__detail-section-title">
                                <i className={strategyIcon} />
                                <FormattedText value={strategyName} />
                            </div>
                            {graph}
                        </div>
                        <div className="col-md-12" id="investmentPlanViewDetailsAnchor">
                            <div className="investment-plan__detail-distribution-container">
                                <div className="investment-plan__distribution-container">
                                    <Accordion
                                        id="actualDistribution"
                                        title={formatText('investmentPlan-distributionTitle')}
                                        expandable
                                        isExpanded={false}
                                        recordEvent={this.recordCurrentAccordion}
                                    >
                                        <AccordionBody name="AccordionBody">
                                            <div className="investment-plan__section-info hidden-xs">
                                                <FormattedText value="investmentPlan-distributionInfo" />
                                            </div>
                                            {donutContent}
                                        </AccordionBody>
                                    </Accordion>
                                </div>
                                <div className="investment-plan__distribution-container">
                                    <Accordion
                                        id="distributionDetails"
                                        title={formatText('investmentPlan-distributionDetailsTitle')}
                                        expandable
                                        isExpanded={false}
                                        recordEvent={this.recordDetailAccordion}
                                    >
                                        <AccordionBody name="AccordionBody">
                                            <div className="investment-plan__table-container">{tableContent}</div>
                                        </AccordionBody>
                                    </Accordion>
                                    <div className="investment-plan__more-info-link">
                                        <p>
                                            <FormattedTextWithComponents
                                                value="investmentPlan-moreInfoText"
                                                injectedComponents={[moreInfoLink]}
                                            />
                                            <FormattedTextWithComponents
                                                value="investmentPlan-moreInfoText3"
                                                injectedComponents={[moreInfoLinkManagement]}
                                            />
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return detailsSection;
    }

    buildInitialInvestmentInput() {
        const { immManagementPlan, immStepsState } = this.props;
        const initialInvestment = immManagementPlan.get('initialContributionAmount');
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        return (
            <div className="investment-plan__initial-investment-input">
                <div className="investment-plan__info">
                    <div className="investment-plan__primary-info">
                        <FormattedText value="investmentPlan-initialInvestment" />
                    </div>
                </div>
                <div className="investment-plan__amount-input">
                    <AmountInput
                        amount={initialInvestment}
                        callback={this.handleInitialContributionChange} // eslint-disable-line
                        error={immManagementPlan.get('errorFlags')}
                        errorMsg={formatText('raInput-amountInputMinimumValidation', [
                            MINIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT,
                        ])}
                        fluid={true}
                        hideFocusZero={true}
                        instructionsMessage={formatText('investmentPlan-instructionInitialInvestment')}
                        keepZeroAndEmpty={true}
                        label={formatText('investmentPlan-amount')}
                        language={getLanguage()}
                        max={MAXIMUM_OBJECTIVE_INITIAL_INVESTMENT_AMOUNT}
                        showBlurZero={false}
                        disabled={disabled}
                    />
                    <span className="investment-plan__amount-input-symbol">{EURO_SYMBOL}</span>
                </div>
            </div>
        );
    }

    buildContributionPeriodicity() {
        const { immManagementPlan, immStepsState } = this.props;
        const contributionAmount = immManagementPlan.get('recurringContributionAmount');
        const periodicity = immManagementPlan.get('periodicity');
        const contributionDay = immManagementPlan.get('recurringContributionDay');
        const disableSelect = contributionAmount < 1;
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);

        let content = null;

        if (immManagementPlan.get('hasRecurringContribution')) {
            content = (
                <div className="investment-plan__contribution-periodicity">
                    <div className="investment-plan__info">
                        <div className="investment-plan__secondary-info">
                            <FormattedText value="investmentPlan-contributionTitle" />
                        </div>
                    </div>
                    <RAContributionPeriodicity
                        amount={contributionAmount}
                        disableSelect={disableSelect}
                        errorMessage={formatText('investmentPlan-contributionErrorMessage')}
                        errorState={immManagementPlan.get('recurringAmountError')}
                        hideFocusZero={true}
                        keepZeroAndEmpty={true}
                        onDayClick={this.handleContributionDayChange}
                        onPeriodicityChange={this.handlePeriodicityChange}
                        onRecurringContributionChange={this.handleRecurringContributionChange}
                        selectedDay={contributionDay}
                        selectedPeriodicity={periodicity}
                        disabled={disabled}
                    />
                </div>
            );
        }

        return content;
    }

    buildModal() {
        let modal = null;

        if (this.state.showRiskModal) {
            modal = (
                <RAIndexRiskModal
                    show={this.state.showRiskModal}
                    onModalClose={this.handleCloseRiskModal}
                    userProfile={this.props.userProfile}
                />
            );
        }

        return modal;
    }

    buildProfileInvestmentPlan() {
        const { immSuitabilityTest, immManagementPlan, immSimulation, immStepsState } = this.props;
        const showContributionPeriodicity = immManagementPlan.get('hasRecurringContribution');
        const investProfileDescription = immSuitabilityTest.getIn(['results', 0, 'clientRiskProfileTitle'], '');
        const strategyContent = this.getStrategyCards();
        const modal = this.buildModal();
        const detailsSection = this.buildDetailsSection();
        const initialInvestmentInput = this.buildInitialInvestmentInput();
        const contributionPeriodicity = this.buildContributionPeriodicity();
        const contributionClass = classNames('investment-plan__widget', {
            'investment-plan__widget-contribution-periodicity': !showContributionPeriodicity,
            'investment-plan__widget-contribution-periodicity--selected': showContributionPeriodicity,
        });
        const investProfileValue = immManagementPlan.get('investProfileValue');
        const isLoading = immSimulation.get('isFetching') || immSimulation.get('isSaving');
        const currentIndex = immStepsState.get('currentStep');
        const disabled = immStepsState.getIn(['steps', currentIndex, 'finished']);
        const buttonContinueDisabled =
            this.state.isClicked ||
            !investProfileValue ||
            isLoading ||
            immManagementPlan.get('initialContributionAmount') < 500 ||
            immManagementPlan.get('errorFlags');

        return (
            <div className="prospects-step-content basic-layering">
                {modal}
                <Headline icon="holders" className="prospects-gutter">
                    <h2>
                        <FormattedText value="investmentPlan-title" />
                    </h2>
                </Headline>
                <div className="investment-plan__header">
                    <div className="investment-plan__header-profile-label">
                        <FormattedText value="investmentPlan-inversorProfile" />
                    </div>
                    <div className="investment-plan__header-profile-type">{investProfileDescription}</div>
                    <div className="investment-plan__header-description">
                        <FormattedText value="investmentPlan-headerDescription" />
                    </div>
                </div>
                <div className="investment-plan__container--salmon">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="investment-plan__section-header">
                                <div className="investment-plan__inversion-profile-title">
                                    <FormattedText value="investmentPlan-investProfileTitle" />
                                </div>
                            </div>
                            <div className="investment-plan__inversion-profile-subtitle">
                                <FormattedText value="investmentPlan-investProfileSubtitle" />
                            </div>
                            <div className="investment-plan__section-button">
                                <button
                                    className="investment-plan__risk-index-button"
                                    onClick={this.handleRiskLinkClick}
                                >
                                    <FormattedText value="investmentPlan-riskIndexButtonLabel" />
                                    <i className="investment-plan__risk-index-icon icon-flag-tracking" />
                                </button>
                            </div>
                            {strategyContent}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="investment-plan__widget">{initialInvestmentInput}</div>
                        </div>
                        <div className="col-md-12">
                            <div className={contributionClass}>
                                <ul className="form__check-list">
                                    <li>
                                        <input
                                            id="showContributionPeriodicity"
                                            checked={showContributionPeriodicity}
                                            className="form__check"
                                            onChange={this.handleContributionCheckboxChange}
                                            type="checkbox"
                                            disabled={disabled}
                                        />
                                        <label htmlFor="showContributionPeriodicity">
                                            <span className="investment-plan__primary-info--check">
                                                <FormattedText value="investmentPlan-contributionPrimaryInfo" />
                                            </span>
                                            <span className="investment-plan__secondary-info">
                                                <FormattedText value="investmentPlan-contributionSecondaryInfo" />
                                            </span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        {showContributionPeriodicity && (
                            <div className="col-md-12">
                                <div className="investment-plan__widget investment-plan__widget-contribution-periodicity">
                                    {contributionPeriodicity}
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {detailsSection && (
                    <div className="investment-plan__container--salmon-light">
                        <div className="row">
                            <div className="col-md-12">{detailsSection}</div>
                        </div>
                    </div>
                )}

                <div className="row">
                    <div className="col-md-12">
                        <div className="investment-plan__info-container">
                            <HighLightedText
                                className="form__hightlight-text form__hightlight-text--disclaimer"
                                icon={<i className="icons icons--icon-info-blue" />}
                            >
                                <FormattedText value="investmentPlan-disclaimerInfo" />
                            </HighLightedText>
                        </div>
                    </div>
                </div>

                <div className="row form__footer">
                    <div className="col-lg-12">
                        <RoadmapNavigation
                            buttonContinueAction={this.onHandleOnContinue}
                            buttonContinueDisabled={buttonContinueDisabled}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildLoginRobo = () => {
        const content = <LoginRoboContainer className="login-robo" />;

        return (
            <div className="ra-test-data-view">
                <RASuitabilityTestWrapper
                    content={content}
                    footerContentClass="footer-padding"
                    buttonPrevAction={() => {
                        this.handlePrevStep();
                    }}
                    buttonCancelAction={() => {
                        this.props.modalCancelActions.showModalCancel();
                    }}
                />
            </div>
        );
    };

    render() {
        const { userProfile, immCheckStatus } = this.props;
        let content = <LoadingSection />;

        if (!userProfile.withoutRobo && immCheckStatus.get('checkStatus')) {
            content = this.buildProfileInvestmentPlan();
        } else if (!immCheckStatus.get('checkStatus')) {
            content = this.buildLoginRobo();
        } else {
            content = (
                <RARejected
                    title={formatText('raSuitabilityTest-roboRejectedTitle')}
                    subtitle={formatText('raSuitabilityTest-roboRejectedSubtitle')}
                    onContinueAction={() => {
                        UtagHelper.recordEventRoboGBI(
                            PATH_RA_REJECTED,
                            EVENT_CATEGORY_RA_REJECTED,
                            EVENT_ACTION_RA_REJECTED,
                            EVENT_DETAIL_BUTTON_NEXT,
                            userProfile
                        );
                        this.gotoNextStep();
                    }}
                    onPrevAction={() => {
                        UtagHelper.recordEventRoboGBI(
                            PATH_RA_REJECTED,
                            EVENT_CATEGORY_RA_REJECTED,
                            EVENT_ACTION_RA_REJECTED,
                            EVENT_DETAIL_BUTTON_PREV,
                            userProfile
                        );
                        this.handlePrevStep();
                    }}
                />
            );
        }

        return content;
    }
}

module.exports.constructor = ProfileInvestmentPlan;
module.exports.ProfileInvestmentPlan = connect(
    state => ({
        immCheckStatus: state.raCheckStatus,
        immExpectedProfitability: state.raExpectedProfitability,
        immHireManagementPlan: state.raHireManagementPlan,
        immManagementPlan: state.raManagementPlan,
        immPortfolioDistribution: state.raPortfolioDistribution,
        immStepsState: state.steps,
        immSuitabilityTest: state.raSuitabilityTest,
        immTimeHorizonCheck: state.raTimeHorizonCheck,
        immSimulation: state.raSimulation,
        userProfile: state.userProfile,
        products: state.products,
    }),
    dispatch => ({
        actions: bindActionCreators(stepsActions, dispatch),
        expectedProfitabilityActions: bindActionCreators(expectedProfitabilityActions, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        raHireManagementPlanActions: bindActionCreators(raHireManagementPlanActions, dispatch),
        raManagementPlanActions: bindActionCreators(raManagementPlanActions, dispatch),
        raPortfolioDistributionActions: bindActionCreators(raPortfolioDistributionActions, dispatch),
        raSuitabilityTestActions: bindActionCreators(raSuitabilityTestActions, dispatch),
        raSimulationActions: bindActionCreators(raSimulationActions, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
        goToErrorsView: bindActionCreators(goToErrorsView, dispatch),
        recordAndSavePage: bindActionCreators(recordAndSavePage, dispatch),
    })
)(ProfileInvestmentPlan);
